import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/CompletedTasks.module.css';

import firstTaskBG from '../static/img/DailyTasks/iconCompletedBG.svg';
import dummyImg from '../static/img/DailyCheckin/iconDailyTaskDummy.png';
import { fetchCompletedTasks } from '../api/challenges';

const CompletedTasks = () => {
  const { t } = useTranslation();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [gameName, setGameName] = useState('');

  useEffect(() => {

    document.title = 'Completed Tasks | Jazz Esl';

    const fetchTasks = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchCompletedTasks();
        // console.log('API Response:', response);

        if (response && response.data) {
          const completedTasks = response.data.map((challenge, index) => ({
            id: challenge.challenge_uuid || index + 1,
            title: challenge.challenge_name || t('challenge'),
            reward: t('win_creds', { prize: challenge.prize || '0' }),
            image: challenge.thumbnail || dummyImg,
            claimed: true,
          }));
          setTasks(completedTasks);
        } else {
          setTasks([]);
        }
      } catch (err) {
        setError(t('err'));
        setTasks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [t]);

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>{t('completed_tasks')}</h2>
      <p className={styles.subheading}>{t('view_completed')}</p>

      {loading && <div className={styles.loading}>{t('loading_t')}</div>}
      {error && <div className={styles.error}>{t('err')}</div>}

      <div className={styles.tasksContainer}>
        {tasks.length > 0 ? (
          tasks.map((task, index) => (
            <div
              key={task.id}
              className={styles.taskCard}
              style={index === 0 ? { paddingTop: '35px', backgroundImage: `url(${firstTaskBG})`, backgroundSize: 'cover', border: 'none', borderLeft: '4px solid white' } : {}}
            >
              <div className={styles.taskText}>
                <p className={styles.taskTitle}>{task.title}</p>
                <p className={styles.taskReward}>{task.reward}</p>
              </div>
              <img
                src={task.image}
                alt={`Task ${index + 1}`}
                className={styles.taskImage}
              />
              <div className={styles.claimed}>{t('claimed')}</div>
            </div>
          ))
        ) : !loading && !error && (
          <div className={styles.noTasks}>{t('no_compl_avail')}</div>
        )}
      </div>
    </div>
  );
};

export default CompletedTasks;